const generateColorIndexFromLayer = async (
    apiRoute: string,
    {
        updateProcessingProgress,
        abortController,
    }: { updateProcessingProgress: (progress: number) => void; abortController: AbortController }
) => {
    const worker = new Worker(new URL("../../VideoColorFinder/layer-worker.ts", import.meta.url))

    return new Promise<{
        superIndex: Uint32Array[]
        anomalyScores: Uint8Array
    }>((resolve, reject) => {
        abortController.signal.addEventListener("abort", () => {
            worker.terminate()
            reject()
        })
        worker.addEventListener("message", (message) => {
            // PHASE 1: Worker Generation
            // Map worker progress (0-1) to the first 90% of the bar
            if (message.data?.progress !== undefined) {
                return updateProcessingProgress(message.data?.progress)
            }

            if (!message.data) reject("Could not parse video")

            // Worker finished, set progress to exactly 90% before starting upload
            updateProcessingProgress(1)
            resolve(message.data)
            worker.terminate()
        })
        const canvas = document.createElement("canvas").transferControlToOffscreen()
        worker.postMessage({ apiRoute, canvas }, [canvas])
    })
}

export { generateColorIndexFromLayer }
